import ky from './kyextended';

const getSubscription = () => ky.get('v1/shopify/subscription/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getSubscriptionById = () => ky.post('v1/shopify/subscription/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    },
}).json();

const upgradeShopifySubscription = (price_id) => ky.post('v1/shopify/create-checkout-session/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    },
    json: {
        price_id,
    }
}).json();

const cancelShopifySubscription = () =>  ky.delete('v1/shopify/subscription/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export {getSubscription, upgradeShopifySubscription, getSubscriptionById, cancelShopifySubscription};